import adminApi from "services/admin-api";

export const workspaceCommerceService = {
  merchandise: {
    list: adminApi.merchandise.list,
  },
  orders: {
    cancel: adminApi.orders.cancel,
    checkout: adminApi.orders.checkout,
    create: adminApi.orders.create,
    list: adminApi.orders.list,
  },
  payments: {
    create: adminApi.payments.create,
    list: adminApi.payments.list,
  },
  walletTransactions: {
    list: adminApi.walletTransactions.list,
  },
  wallets: {
    me: adminApi.wallets.me,
    topUp: adminApi.wallets.topUp,
    transfer: adminApi.wallets.transfer,
  },
};
